define((require) => {
    "use strict";

    const Marionette              = require("marionette");
    const template                = require("ui/viewer/cnc/ExperienceCncViewer.tpl");

    /**
     * Experience preview page.
     *
     * <p>Shows an experience CNC viewer.</p>
     *
     * @class ExperienceCncViewer
     * @constructor
     */
    return Marionette.Layout.extend({
        template: template,

        templateHelpers() {
            const {fitInHeight, groupsDisable, model} = this.options;
            const experienceId = model.has("experienceId") ? model.get("experienceId") : model.get("experience").id;
            const fixedSize = model.get("fixedSize");
            const templateId = model.get("templateId");
            let viewerStyle;
            if (fixedSize) {
                viewerStyle = `width: ${fixedSize.width}px; height: ${fixedSize.height}px;`;
            }

            return {
                fitInHeight: fitInHeight,
                groupsDisable: groupsDisable,
                viewerStyle,
                experienceId,
                templateId
            };
        },

        initialize: function() {
            if (this.options.startEvent) {
                this.listenTo(this.model.get("experience"), this.options.startEvent, this.startCnc);
            }
        },

        onShow: function() {
            if (!this.options.startEvent) {
                this.startCnc();
            }
        },

        _triggerEvent: function(eventName) {
            let event; // The CNC start custom event that will be created

            if (document.createEvent) {
                // Normal browsers
                event = document.createEvent("HTMLEvents");
                event.initEvent(eventName, true, true);
                event.eventName = eventName;
                document.dispatchEvent(event);
            } else {
                // Old IE support
                event = document.createEventObject();
                event.eventName = eventName;
                event.eventType = eventName;
                document.fireEvent(`on${event.eventType}`, event);
            }
        },

        startCnc: function() {
            this._triggerEvent("ZmagsInitialize");
        },

        onClose: function() {
            this._triggerEvent("ZmagsCleanup");
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/viewer/cnc/ExperienceCncViewer.js